import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=425f2c3c&scoped=true&"
import script from "./HomeSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HomeSwiper.vue?vue&type=style&index=0&id=425f2c3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f2c3c",
  null
  
)

export default component.exports